// AFTER (The Correct Way)
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ShopContextProvider from './Context/ShopContext'; // <-- IMPORT IT
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ShopContextProvider> {/* <-- WRAP IT HERE */}
       <App />
    </ShopContextProvider>
  </React.StrictMode>
);

reportWebVitals();